import { Typography } from "@components";
import React, { FC, PropsWithChildren } from "react";

import { formulas } from "./constants";

const Tag: FC<PropsWithChildren> = ({ children }) => (
  <div className="inline-block rounded bg-primary/10 px-2 py-1 text-xs font-bold">
    {children}
  </div>
);

export const FormulaList: FC = () => (
  <div>
    <div className="mb-2">
      <span className="text-xl">计算方式</span>
      <Typography.Muted className="inline text-xs">
        （高精度计算）
      </Typography.Muted>
    </div>
    <div className="flex flex-col divide-y text-sm *:py-2">
      {formulas.map((formula, index) => (
        <div key={index}>
          <div className="mb-1">
            {formula.required && <span className="text-red-400">*</span>}
            <strong>{formula.title}</strong>
            <Typography.Muted className="inline text-xs">
              {formula.description}
            </Typography.Muted>
          </div>
          <div className="flex flex-wrap gap-1">
            {formula.tags.map((item, idx) => (
              <Tag key={idx}>{item}</Tag>
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default FormulaList;
